module.exports = __webpack_public_path__ + "img/ele2.01e0e923.png";